import DangerCircleIcon from "assets/icons/DangerCircleIcon";
import XIcon from "assets/icons/XIcon";

import styles from "./style.module.scss";

function AbortModal({ onCancelClick, onConfirmClick }: AbortModalProps) {
  return (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div
        className={styles.abortModalContainer}
        data-testid="abort-enrichment-container"
      >
        <div className={styles.abortModalHeader}>
          <div className={styles.titleContainer}>
            <DangerCircleIcon variant="filled" />
            <span className={styles.title}>Abort Operation</span>
          </div>

          <span onClick={onCancelClick} className={styles.crossIcon}>
            <XIcon />
          </span>
        </div>

        <span className={styles.divider} />

        <div className={styles.subtitle}>
          Are you sure you want to abort this operation?
        </div>

        <span className={styles.description}>
          Selecting this action will permanently remove the Dataset, images,
          clusters, labels and all their related information
        </span>
        <span className={styles.divider} />

        <div className={styles.buttonContainer}>
          <div className={styles.cancelButton} onClick={onCancelClick}>
            Cancel
          </div>
          <div className={styles.confirmButton} onClick={onConfirmClick}>
            Confirm
          </div>
        </div>
      </div>
    </div>
  );
}

export default AbortModal;

interface AbortModalProps {
  onCancelClick: () => void;
  onConfirmClick: () => void;
}
